import { type StudioMetadata, type Availability, type IStudio, type StudioInfo, StudioStatus, StandardAvailability } from '../types/studio'
import { type Studio as GraphQLStudio, type S3Object } from '../graphql/types'
import { type IUserProfile } from '../types/user'
import { NotYetImplemented } from '../utils'
import StorageObject from '../utils/storage_object'
import { UserService } from '..'
import { TimeRange, Timezone } from '../types/common'

export default class Studio implements IStudio {
  id: string
  status: StudioStatus
  info: StudioInfo
  ownerId: string
  private ownerProfile: IUserProfile | undefined

  static parseStandardAvailability (standardAvailability: any): StandardAvailability {
    const {
      timezone = Timezone.NEW_YORK,
      MONDAY = [],
      TUESDAY = [],
      WEDNESDAY = [],
      THURSDAY = [],
      FRIDAY = [],
      SATURDAY = [],
      SUNDAY = []
    } = standardAvailability ?? {}
    return {
      timezone: timezone as Timezone,
      MONDAY: MONDAY as TimeRange[],
      TUESDAY: TUESDAY as TimeRange[],
      WEDNESDAY: WEDNESDAY as TimeRange[],
      THURSDAY: THURSDAY as TimeRange[],
      FRIDAY: FRIDAY as TimeRange[],
      SATURDAY: SATURDAY as TimeRange[],
      SUNDAY: SUNDAY as TimeRange[]
    }
  }

  constructor (graphQLResponse: GraphQLStudio) {
    this.id = graphQLResponse.id
    this.status = graphQLResponse.status ?? StudioStatus.ACTIVE
    const studioPictures = graphQLResponse.info.studioPictures.map(
      (pictureS3Object) => new StorageObject(pictureS3Object as S3Object)
    )
    this.info = {
      title: graphQLResponse.info.title,
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      description: graphQLResponse.info.description as string,
      rate: graphQLResponse.info.rate,
      maxOccupancy: graphQLResponse.info.maxOccupancy,
      minSessionMinutes: graphQLResponse.info.minSessionMinutes ?? 30,
      location: graphQLResponse.info.location,
      studioPictures
    }

    this.ownerId = graphQLResponse.ownerUserId
  }

  get metadata (): StudioMetadata {
    return {
      id: this.id,
      ownerId: this.ownerId,
      title: this.info.title,
      rate: this.info.rate,
      maxOccupancy: this.info.maxOccupancy,
      coverPicture: this.info.studioPictures[0],
      location: {
        city: this.info.location.city,
        state: this.info.location.state
      }
    }
  }

  async getOwnerProfile (): Promise<IUserProfile> {
    if (!this.ownerProfile) {
      this.ownerProfile = await UserService.getUserProfileByUserId(this.ownerId) as IUserProfile
    }
    return this.ownerProfile
  }

  async getAvailability (): Promise<Availability> {
    return await NotYetImplemented()
  }
}
